import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=f81715e2"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts"
import style0 from "./GloablSearch.module.scss?vue&type=style&index=0&prod&lang=scss&module=styles&external"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports